(async function () {
  'use strict';

  // Wait for Backbone to be available
  let attempts = 0;
  while (
    (typeof window.Backbone === 'undefined' || !window.Backbone?.View) &&
    attempts < 50
  ) {
    console.log('[VIEWS] Waiting for Backbone... attempt', attempts + 1);
    await new Promise((resolve) => setTimeout(resolve, 100));
    attempts++;
  }

  if (typeof window.Backbone === 'undefined' || !window.Backbone.View) {
    console.error(
      '[VIEWS] Backbone or Backbone.View not available after waiting, cannot initialize views'
    );
    return;
  }

  console.log(
    '[VIEWS] Initializing views with Backbone:',
    typeof window.Backbone
  );

  window.APP = window.APP || {
    Routers: {},
    Collections: {},
    Models: {},
    Views: {},
  };

  window.ChatStateManager = {
    currentMode: null,

    saveState: function () {
      if (window.history && window.history.replaceState) {
        const state = {
          mode: this.currentMode,
          room_name: fixtures.room_name,
          room_ais: fixtures.room_ais,
          currentAI: fixtures.currentAI,
          timestamp: Date.now(),
        };
        window.history.replaceState(state, '', window.location.pathname);
      }
    },

    restoreState: function (state) {
      if (state) {
        fixtures.room_name = state.room_name;
        fixtures.room_ais = state.room_ais;
        fixtures.currentAI = state.currentAI;
        this.currentMode = state.mode;

        if (state.mode === 'chatroom' && fixtures.room_name) {
          this.switchToChatroom({
            room_name: fixtures.room_name,
            room_ais: fixtures.room_ais,
          });
        } else if (state.mode === 'ai-chat' && fixtures.currentAI) {
          this.switchToAIChat(fixtures.currentAI);
        }
      }
    },

    switchToChatroom: function (config) {
      if (window.switchChatMode) {
        this.currentMode = 'chatroom';
        // Avoid changing URL when switching programmatically from homepage
        window.switchChatMode('chatroom', config, true);
        this.saveState();
      } else if (
        window.NavigationManager &&
        typeof window.NavigationManager.switchToChatroom === 'function'
      ) {
        window.NavigationManager.switchToChatroom({
          data: config,
          mode: 'chatroom',
        });
      }
    },

    switchToAIChat: function (aiChar) {
      if (window.switchChatMode) {
        this.currentMode = 'ai-chat';
        // Avoid changing URL when switching programmatically from homepage
        window.switchChatMode('ai-chat', { ai_char: aiChar }, true);
        this.saveState();
      } else if (
        window.NavigationManager &&
        typeof window.NavigationManager.switchToChat === 'function'
      ) {
        window.NavigationManager.switchToChat({
          data: { ai_char: aiChar },
          mode: 'chat',
        });
      }
    },

    detectCurrentMode: function () {
      if (fixtures.room_name) {
        return 'chatroom';
      } else if (fixtures.currentAI) {
        return 'ai-chat';
      }
      return null;
    },
  };

  APP.Views['/'] = window.Backbone.View.extend({
    initialize: function (_options) {},

    render: function () {
      var self = this;

      // Keep homepage as homepage - no automatic redirect/switch
      // User can explicitly choose to start chatting

      return self;
    },
  });

  let aiChatView = window.Backbone.View.extend({
    initialize: function (options) {
      var raw = options.args[0] || '';
      this.currentName =
        window.RouteUtils && RouteUtils.normalizeCharacterSlugToName
          ? RouteUtils.normalizeCharacterSlugToName(raw)
          : String(raw).replace(/-/g, ' ');
    },

    render: async function () {
      var self = this;

      if (!window.onceGameInit) {
        return;
      }

      var currentAI = dataAccessor.aisByName[this.currentName];

      if (!currentAI) {
        try {
          // Prefer local default when no name provided
          if (!this.currentName) {
            currentAI = window.DefaultAICharacter || null;
          }
          if (!currentAI) {
            currentAI = await dataAccessor.getAIByName(this.currentName);
          }
          if (!currentAI || currentAI.error) {
            console.warn('Character data has errors or is missing:', currentAI);
            currentAI = {
              name: this.currentName || 'Unknown Character',
              description: 'Character information unavailable',
              greeting: '',
              avatar_file_name: '',
              error: true,
            };
          }
        } catch (err) {
          console.error('Error fetching AI character:', err);
          currentAI = {
            name: this.currentName || 'Unknown Character',
            description: 'Character information unavailable',
            greeting: '',
            avatar_file_name: '',
            error: true,
          };
        }
      }

      if (!currentAI || currentAI.error) {
        console.warn(
          'Character data has errors or is missing, using fallback display'
        );
        currentAI = currentAI || {
          name: this.currentName || 'Unknown Character',
          description: 'Character information unavailable',
          greeting: '',
          avatar_file_name: '',
          error: true,
        };
      }

      window.ChatStateManager.switchToAIChat(currentAI);

      try {
        $('#add-chat-dialog')[0].close();
      } catch {
        // Dialog may not exist or already be closed
      }

      return self;
    },
  });
  APP.Views['/ai-chat'] = aiChatView;

  APP.Views['/ai-chat/:name'] = aiChatView;

  let roomsView = window.Backbone.View.extend({
    initialize: function (options) {
      this.currentRoomkey = options.args[0];
    },

    fetchRoomData: function (roomKey) {
      return new Promise((resolve, reject) => {
        $.ajax({
          url: '/api/get-room/' + roomKey,
          type: 'GET',
          success: function (data) {
            resolve(data);
          },
          error: function (err) {
            reject(err);
          },
        });
      });
    },

    render: async function () {
      var self = this;

      if (!window.onceGameInit) {
        return;
      }

      if (this.currentRoomkey && !fixtures.room_name) {
        try {
          const roomData = await this.fetchRoomData(this.currentRoomkey);
          if (roomData && roomData.name) {
            window.ChatStateManager.switchToChatroom({
              room_name: roomData.name,
              room_ais: roomData.ais || {},
            });

            ReRenderCurrentGame();

            if (
              fixtures.room_ais &&
              Object.keys(fixtures.room_ais).length > 0
            ) {
              renderAIsInRoom(fixtures.room_ais);
              renderAIsInRoomList(fixtures.room_ais);
            }
          } else {
            console.error('Failed to fetch room data or room not found');

            window.location.href = '/';
            return;
          }
        } catch (err) {
          console.error('Error fetching room data:', err);

          window.location.href = '/';
          return;
        }
      } else if (fixtures.room_name) {
        window.ChatStateManager.switchToChatroom({
          room_name: fixtures.room_name,
          room_ais: fixtures.room_ais || {},
        });

        ReRenderCurrentGame();

        if (fixtures.room_ais && Object.keys(fixtures.room_ais).length > 0) {
          renderAIsInRoom(fixtures.room_ais);
          renderAIsInRoomList(fixtures.room_ais);
        }
      } else if (!this.currentRoomkey) {
        return self;
      } else {
        console.error('Room view rendered without room data');
        window.location.href = '/';
        return;
      }

      try {
        $('#add-chat-dialog')[0].close();
      } catch {
        // Dialog may not exist or already be closed
      }

      return self;
    },
  });
  APP.Views['/r'] = roomsView;
  APP.Views['/r/:roomkey'] = roomsView;
})();
